module.exports = __webpack_public_path__ + "static/media/robosgdemonstration.848e9e9f.jpeg";